import { useEffect, useState } from "react";
import { Users, TrendingUp, PhoneCall, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

function getToken() { return localStorage.getItem("token"); }

export default function Dashboard() {
  const [leads, setLeads] = useState([]);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${getToken()}` };
    Promise.all([
      fetch("/api/leads", { headers }).then(res => res.json()),
      fetch("/api/activities", { headers }).then(res => res.json()),
    ]).then(([l, a]) => {
      setLeads(Array.isArray(l) ? l : []);
      setActivities(Array.isArray(a) ? a : []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const stats = {
    total: leads.length,
    newLeads: leads.filter(l => l.stage === "new").length,
    won: leads.filter(l => l.stage === "won").length,
    value: leads
      .filter(l => !["won","lost"].includes(l.stage))
      .reduce((s, l) => s + (l.value || 0), 0),
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Dashboard</div>
          <div className="page-subtitle">Pipeline overview</div>
        </div>
        <Link to="/leads" className="btn btn-primary">+ New Lead</Link>
      </div>

      <div className="stats-grid">
        {[
          { label: "Total Leads", value: stats.total, icon: <Users size={20} color="#2563eb" />, cls: "blue" },
          { label: "New Leads", value: stats.newLeads, icon: <TrendingUp size={20} color="#7c3aed" />, cls: "purple" },
          { label: "Deals Won", value: stats.won, icon: <PhoneCall size={20} color="#16a34a" />, cls: "green" },
          { label: "Pipeline Value", value: `$${stats.value.toLocaleString()}`, icon: <DollarSign size={20} color="#ea580c" />, cls: "orange" },
        ].map(s => (
          <div key={s.label} className="stat-card">
            <div className={`stat-icon ${s.cls}`}>{s.icon}</div>
            <div>
              <div className="stat-label">{s.label}</div>
              <div className="stat-value">{loading ? "—" : s.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        {/* Recent Leads */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Recent Leads</span>
            <Link to="/leads" style={{ fontSize: 12, color: "#2563eb", textDecoration: "none" }}>View all</Link>
          </div>
          <div>
            {loading
              ? <p style={{ padding: 16, color: "#94a3b8", fontSize: 13 }}>Loading...</p>
              : leads.length === 0
                ? <p style={{ padding: 16, color: "#94a3b8", fontSize: 13 }}>No leads yet.</p>
                : leads.slice(0, 6).map(lead => (
                  <div key={lead.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderTop: "1px solid #f1f5f9" }}>
                    <div className="td-name">
                      <strong>{lead.name}</strong>
                      <span>{lead.company || lead.email || "—"}</span>
                    </div>
                    <span className={`badge badge-${lead.stage}`}>{lead.stage}</span>
                  </div>
                ))
            }
          </div>
        </div>

        {/* Recent Activity */}
        <div className="card">
          <div className="card-header"><span className="card-title">Recent Activity</span></div>
          <div style={{ padding: "0 16px" }}>
            {loading
              ? <p style={{ padding: "16px 0", color: "#94a3b8", fontSize: 13 }}>Loading...</p>
              : activities.length === 0
                ? <p style={{ padding: "16px 0", color: "#94a3b8", fontSize: 13 }}>No activities yet.</p>
                : activities.slice(0, 6).map(a => (
                  <div key={a.id} className="activity-item">
                    <span className="badge badge-outline" style={{ textTransform: "capitalize" }}>{a.type}</span>
                    <span className="activity-desc">{a.description || "No description"}</span>
                  </div>
                ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}